import { useAmp } from 'next/amp';
import { useLink } from 'utils/hooks/useLink';
import { Container, Logo } from './style';

export const MainLogo = ({ logo = '' }) => {
  const mainHref = useLink();

  const isAmp = useAmp();

  return (
    <Container href={mainHref}>
      {isAmp ? (
        <amp-img
          src="/images/cosMetologyLogo.svg"
          width="335"
          height="65"
          alt="Logo"
        ></amp-img>
      ) : (
        <Logo priority loading="eager" name={logo} />
      )}
    </Container>
  );
};
